import axios from "../../../utils/axios";

export const getRelatedPosts = async ({id, tags}) => {

    const limit = 5;
    let query =
        tags?.length > 0 ? 
        tags.map((tag) => `tags_like=${tag}`).join("&") + `&id_ne=${id}&_limit=${limit}` :
         `id_ne=${id}&_limit=${limit}`;

    const response = await axios.get(`/blogs?${query}`);

    return response.data;
};